import { render } from "./m-switch-table.vue?vue&type=template&id=930c2b2c&scoped=true&ts=true"
import script from "./m-switch-table.vue?vue&type=script&lang=ts"
export * from "./m-switch-table.vue?vue&type=script&lang=ts"

import "./m-switch-table.vue?vue&type=style&index=0&id=930c2b2c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newb\\bnet2.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-930c2b2c"]])

export default __exports__